import { render, staticRenderFns } from "./EmailAuthCode.vue?vue&type=template&id=1536da20&scoped=true"
import script from "./EmailAuthCode.vue?vue&type=script&lang=js"
export * from "./EmailAuthCode.vue?vue&type=script&lang=js"
import style0 from "./EmailAuthCode.vue?vue&type=style&index=0&id=1536da20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1536da20",
  null
  
)

export default component.exports